import { useUser } from '@/context/userContext';
import { Navigate, Outlet } from 'react-router';
import { USER_ROLE_MAP } from '@/const/user';
import { getDashboardRedirectPath } from '@/bundle/Auth/LoginFlow/LoginPage/const/const';
import { hasBillingSubscription, isEnterprisePlanType } from '@/helpers/billingHelpers';
import { useSubscriptionStatus } from '../shared/hooks/useSubscriptionStatus';
import { isAcceptedMasterServiceAgreement } from '@/helpers/userHelpers';
import { getAcceptMasterServiceAgreementPath } from '../Auth/AdminOnboardingFlow/AcceptMasterServiceAgreementPage/path';

export const SubscriptionPurchasedProtectedRoute = () => {
  const { user } = useUser();
  const hasSubscription = hasBillingSubscription(user);
  const { isCancelledSubscription } = useSubscriptionStatus();
  const isEnterprisePlan = isEnterprisePlanType(user);
  const isAgreementAccepted = isAcceptedMasterServiceAgreement(user);

  if (isEnterprisePlan || (hasSubscription && !isCancelledSubscription)) {
    return (
      <Navigate
        to={{
          pathname: getDashboardRedirectPath(USER_ROLE_MAP.MASTER_ADMIN),
          search: location.search,
        }}
        replace
      />
    );
  }

  if (!isAgreementAccepted) {
    return <Navigate to={getAcceptMasterServiceAgreementPath()} replace />;
  }

  return <Outlet />;
};
